<template lang="html">
  <div class="main">
    <SoundslidesPlayer
      v-if="dataReceived"
      ref="editPlayer"
      :editing_initial_slide_data="slideArray"
      :editing_initial_overlay_data="overlayArray"
      :editing_initial_settings_data="displaySettings"
      :editing_audio_source_url="audioUrl"
      :editing_audio_duration="audioDuration"
      :force_preload="true"
      :fillscreen="true"
      @onSlideChange="slideChange"
      @onTimeUpdate="timeUpdate"
    />
  </div>
</template>

<script>
import SoundslidesPlayer from "@/components/SoundslidesPlayer/SoundslidesPlayer";
import { returnEmptyWaveBlob } from "@/components/SoundslidesPlayer/dynamicAudioGeneration";
export default {
  name: "Updating",
  components: {
    SoundslidesPlayer
  },
  data() {
    return {
      dataReceived: false,
      slideArray: [],
      overlayArray: [],
      displaySettings: {},
      audioUrl: "",
      audioDuration: 0
    };
  },
  computed: {},
  mounted() {
    window.addEventListener("message", this.receiveMessageFromEditor);
    this.sendMessageToEditor();
  },
  methods: {
    receiveMessageFromEditor(e) {
      //console.log("receiveMessageFromEditor");
      //console.log(e.origin);
      //console.log(e.data);
      var approvedOrigins = [
        "http://127.0.0.1:8081",
        "http://127.0.0.1:8080",
        "https://soundslides.org",
        "https://app.soundslides.com",
        "https://soundslides-stage.firebaseapp.com"
      ];
      if (
        !approvedOrigins.includes(e.origin) &&
        !e.origin.endsWith("soundslides-services-dev-98.netlify.com")
      ) {
        // Non-approved origin.
        return;
      }
      if ("gotoAndPause" in e.data) {
        // Change player currentTime.
        this.$refs["editPlayer"].gotoAndPause(e.data.gotoAndPause);
        this.$refs["editPlayer"].controlsTweenOut();
        this.$refs["editPlayer"].hideInitialUI();
        return;
      }
      if (!e.data.slideArray) {
        // Hotreloading webpack sends copius messages.
        return;
      }
      if (!this.dataReceived) {
        // Initial setup.
        this.slideArray = e.data.slideArray;
        this.overlayArray = e.data.overlayArray;
        this.displaySettings = e.data.displaySettings;
        var source_id = e.data.audio.source_id;
        var filename = e.data.audio.filename;
        if (filename === "SILENT_AUDIO_ONLY") {
          // Create new silent audio blob link.
          var sec_per_image =
            this.displaySettings.fakeAudioPlaybackSecsPerImage || 4;
          this.audioUrl = returnEmptyWaveBlob(
            sec_per_image * this.slideArray.length
          );
          console.log(this.audioUrl);
        } else {
          this.audioDuration = e.data.audio.duration;
          this.audioUrl = `https://cdn3.soundslides.com/audio/${source_id}/${filename}`;
        }

        this.dataReceived = true;
      } else {
        // Pass this all to the editor.
        if (e.data.noTimelineUpdateNeeded) {
          this.$refs["editPlayer"].setSlideDataWithoutTimelineUpdate(
            e.data.slideArray,
            e.data.overlayArray,
            e.data.displaySettings,
            e.data.audio
          );
        } else {
          this.$refs["editPlayer"].setSlideData(
            e.data.slideArray,
            e.data.overlayArray,
            e.data.displaySettings,
            e.data.audio
          );
        }
      }
    },
    sendMessageToEditor() {
      // Send this to any iFrame. Nothing of importance is being transmitted.
      window.parent.postMessage({ initialized: true }, "*");
    },
    slideChange(slideIndex) {
      // Send this to any iFrame. Nothing of importance is being transmitted.
      window.parent.postMessage(
        { item: "slideChange", value: slideIndex },
        "*"
      );
    },
    timeUpdate(currentTime) {
      // Send this to any iFrame. Nothing of importance is being transmitted.
      window.parent.postMessage(
        { item: "timeUpdate", value: currentTime },
        "*"
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.main {
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-transform-style: preserve-3d;
  -moz-transform-style: preserve-3d;
  transform-style: preserve-3d;
}
.center {
  position: relative;
  top: 33%;
  left: 50%;
  transform: translateX(-50%) translateY(-33%);
  max-width: 100%;
  max-height: 100%;
}
</style>
